








































import { mapActions, mapState } from 'vuex';

// Components
import SettingsCard from '@adobe/edex/frontend/views/externalCourse/settings/externalCourse-settings-basic.vue';
import CompletionCard from '@adobe/edex/frontend/views/externalCourse/settings/externalCourse-settings-completion-behavior.vue';
import EducatorsCard from '@adobe/edex/frontend/views/externalCourse/settings/externalCourse-settings-educators.vue';
import { ChangeLogType } from '@adobe/edex/frontend/views/course/settings/constants';

const CHILDREN_REVERT_LENGTH = 3;
export default {
  data() {
    return {
      diffMap: {},
      hasDiffs: false,
      revertAll: false,
      childrenReverted: 0,
      loading: false,
      error: false,
    };
  },
  components: {
    SettingsCard,
    CompletionCard,
    EducatorsCard,
  },
  computed: {
    ...mapState('externalCourseModule', ['externalCourse']),
    ...mapState('member', ['member']),
  },
  watch: {
    async childrenReverted(current) {
      if (this.revertAll && current == CHILDREN_REVERT_LENGTH) {
        this.diffMap = {};
        this.hasDiffs = false;
        this.revertAll = false;
        this.childrenReverted = 0;
      }
    },
  },
  methods: {
    ...mapActions('externalCourseModule', ['updateCourse']),
    onChange(changeLog: ChangeLogType) {
      this.diffMap[changeLog.name] = changeLog;
      const newDiffs = this.checkDiffs();
      if (newDiffs != this.hasDiffs) {
        this.hasDiffs = newDiffs;
      }
    },
    checkDiffs() {
      return Object.values(this.diffMap)
        .map((changeLog: ChangeLogType) => changeLog.hasDiff)
        .some(Boolean);
    },
    onRevertAllHandled() {
      this.childrenReverted = this.childrenReverted + 1;
    },
    canViewSettingsTab() {
      return this.member?.isAdmin || this.member?.isShellCourseAdmin;
    },
    async submitCourseUpdates() {
      this.loading = true;
      const changeLogs = Object.values(this.diffMap) as ChangeLogType[];
      const payload = {};
      changeLogs.forEach((value) => {
        if(value.hasDiff) {
          payload[value.name] = value.data;
        }
      })
      try {
        const params = {
          shellCourseID: this.externalCourse.shell_course_id,
          payload,
        }
        await this.updateCourse(params);
        this.revertAll = true;
      } catch (e) {
        console.log('UPDATE ERROR: ', e);
      }
      this.loading = false;
    },
  },
};
